import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LegalProfessionalSignUpForm } from '../components/user/LegalProfessionalSignUpForm';

const LegalProfessionalSignupPage = () => {
  // Ensure body has the right class for scrolling
  useEffect(() => {
    // Detect iOS for specific fixes
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                 (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    
    if (isIOS) {
      document.documentElement.classList.add('ios');
      document.body.classList.add('ios');
    }
    
    document.documentElement.classList.add('allow-scroll');
    document.body.classList.add('allow-scroll');
    document.body.style.backgroundColor = '#1E0B38';
    
    return () => {
      if (isIOS) {
        document.documentElement.classList.remove('ios');
        document.body.classList.remove('ios');
      }
      document.documentElement.classList.remove('allow-scroll');
      document.body.classList.remove('allow-scroll');
      document.body.style.backgroundColor = '';
    };
  }, []);

  return (
    <div className="auth-page-container" style={{ background: 'linear-gradient(180deg, #301555 0%, #411C73 50%, #1E0B38 100%)' }}>
      {/* Background decorative elements - fixed position */}
      <div className="fixed top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[10%] left-[15%] w-64 h-64 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
        <div className="absolute top-[40%] right-[15%] w-72 h-72 bg-yellow-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-[10%] left-[35%] w-80 h-80 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-4000"></div>
      </div>
      
      {/* Content container */}
      <div className="mx-auto px-4 py-10 relative z-10">
        <div className="w-full max-w-md mx-auto">
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-xl p-8 space-y-6 border border-white/20">
            {/* Header */}
            <div className="text-center space-y-2">
              <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
                Create a Legal Professional Account
              </h1>
              <p className="text-gray-300">Join our network of legal experts</p>
            </div>
            
            <LegalProfessionalSignUpForm />
            
            <div className="space-y-3 text-center">
              <p className="text-gray-400">
                Already have an account?{' '}
                <Link to="/signin" className="text-purple-400 hover:text-purple-300 font-medium transition-colors">
                  Sign in
                </Link>
              </p>
              
              <p className="text-sm text-gray-400">
                Looking for a regular account?{' '}
                <Link to="/signup" className="text-purple-400 hover:text-purple-300 font-medium transition-colors">
                  Create a user account
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalProfessionalSignupPage; 